export const FILETYPES=".jpeg, .jpg, .png, .pdf, .jfif, .bmp, .webp, .heic, .heif"

export const FILETYPESWithoutHeifHeic=".jpeg, .jpg, .png, .jfif, .bmp, .webp"

export  const MAX_FILE_SIZE = 10 * 1024 * 1024;